export default __webpack_public_path__ + "static/media/oscer-gif-chat-desktop.95d73fa8.webm";